import React from "react";
import { Avatar, Col, Row, Space, Table, Tag, Typography } from "antd";
import { useClientRefine } from "hook/clients/useClient";
import { CLIENT_PERMISSIONS } from "store/string";
import TableRemove from "./table_remove";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ClientTable = () => {
  // -------------------------- VAR -----------------------------
  const data = useClientRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      title: "Họ và tên",
      dataIndex: "email",
      key: "email",
      render: (_, record) => getEmail(record),
    },
    {
      title: "Quyền truy cập",
      dataIndex: "clients",
      key: "clients",
      render: (value) => getClients(value),
    },
    {
      title: "Thao tác",
      dataIndex: "#",
      key: "#",
      width: 100,
      align: "center",
      fixed: "right",
      render: (_, record) => <TableRemove data={record} />,
    },
  ];

  const getEmail = (record) => {
    const email = record?.email;
    const fullName = record.fullName;
    const avatar = email?.slice(0, 2);
    return (
      <Space>
        <Avatar size={40}>{avatar}</Avatar>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Typography.Text>{fullName || email}</Typography.Text>
          <Typography.Text type="secondary">{email}</Typography.Text>
        </div>
      </Space>
    );
  };

  const getClients = (value) => {
    return (
      <Row>
        {value?.map((item) => {
          const exist = CLIENT_PERMISSIONS?.find((c) => c?.value === item);
          const label = exist?.label;
          return (
            <Col key={item}>
              <Tag>{label}</Tag>
            </Col>
          );
        })}
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <div style={{ width: "100%" }}>
      <Table
        scroll={{ x: "max-content" }}
        size="small"
        rowKey={"id"}
        columns={columns}
        dataSource={data || []}
      />
    </div>
  );
};
export default ClientTable;
